import Clarity from '@microsoft/clarity';
import { Frame } from '@shopify/polaris';
import React, { useCallback, useEffect, useState } from 'react';
import { Outlet, ScrollRestoration } from 'react-router';
import sessionIdUtils from '../../utils/sessionIdUtils';

type MainFrameProps = { children?: React.ReactNode };

const MainFrame: React.FC<MainFrameProps> = ({ children }) => {
    const clarityProjectId = import.meta.env.VITE_APP_CLARITY_PROJECT_ID;

    const [mobileNavigationActive, setMobileNavigationActive] = useState<boolean>(false);

    const toggleMobileNavigationActive = useCallback(
        () => setMobileNavigationActive((mobileNavigationActive) => !mobileNavigationActive),
        []
    );

    useEffect(() => {
        if (clarityProjectId) {
            Clarity.init(clarityProjectId);
            try {
                Clarity.identify(
                    shopify?.config?.shop,
                    sessionIdUtils.getSessionId(),
                    undefined,
                    shopify?.config?.shop
                );
            } catch (error) {
                console.warn('Clarity.identify error', error);
            }
            // Clarity.consentV2({ analytics_Storage: 'granted', ad_Storage: 'denied' });
        }
    }, []);

    return (
        <Frame showMobileNavigation={mobileNavigationActive} onNavigationDismiss={toggleMobileNavigationActive}>
            <Outlet />
            <ScrollRestoration />
        </Frame>
    );
};

export default MainFrame;
